import { createContext, useContext, useEffect, useReducer, } from 'react';
import ajaxStudent from '../util/remote/ajaxStudent';

const initialState = { 
    metaData: null,
    currentPage: 1,
    listing: null,
    mounted: false,
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
};


const FeesBalanceContext = createContext();

export const FeesBalanceProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

   /**
   * Only fetch more pages if page is already mounted
   */
  useEffect(()=>{
    if(state.mounted){
      getFeesBalances();
    }
  }, [state.currentPage])


  const getFeesBalances = async (refresh = false) => {
    dispatch({ type: "mounted", payload: true });

    if (refresh) {
        dispatch({ type: "listing", payload: null });
        dispatch({ type: "metaData", payload: null });
        setCurrentPage(1);
    }

    const server_response = await ajaxStudent.fetchFeesBalances({
        page: refresh ? 1 : state.currentPage,
    });


    if (server_response.status === "OK") {
        const newTransactions = server_response.details.data;

        dispatch({
            type: "listing",
            payload: refresh ? newTransactions
                    : state.listing
                    ? [...state.listing, ...newTransactions]
                    : newTransactions
        });

        dispatch({ type: "metaData", payload: server_response.details.meta });
    } else {
        dispatch({ type: "listing", payload: "404" });
        dispatch({ type: "metaData", payload: "404" });
    }
};

  

 const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
 }
  

  

  return(
    <FeesBalanceContext.Provider value={{
      ...state,
      dispatch,
      getFeesBalances,
      setCurrentPage,
      }}>
      {children}
    </FeesBalanceContext.Provider>
  )

}

export const useFeesBalance = ()=>useContext(FeesBalanceContext);

